import { useQuery } from "@tanstack/react-query";
import { Card, CardContent } from "@/components/ui/card";
import { TrendingUp, TrendingDown, DollarSign, Wallet } from "lucide-react";
import { contasReceberService } from "@/features/financeiro/services/contasReceberService";

const fmt = (value: number) =>
  value.toLocaleString("pt-BR", { style: "currency", currency: "BRL" });

const colorMap = {
  primary: "bg-primary/10 text-primary",
  success: "bg-success/10 text-success",
  destructive: "bg-destructive/10 text-destructive",
  warning: "bg-warning/10 text-warning",
};

export function DashboardStats({ modoEdicao: _modoEdicao = false }: { modoEdicao?: boolean } = {}) {
  const { data: resumo, isLoading } = useQuery({
    queryKey: ["financeiro-resumo"],
    queryFn: contasReceberService.getResumo,
  });

  const stats = [
    {
      title: "A Receber",
      value: isLoading ? "..." : fmt(resumo?.totalReceber ?? 0),
      sub: "Em aberto",
      icon: TrendingUp,
      color: "primary" as const,
    },
    {
      title: "A Pagar",
      value: isLoading ? "..." : fmt(resumo?.totalPagar ?? 0),
      sub: "Em aberto",
      icon: TrendingDown,
      color: "destructive" as const,
    },
    {
      title: "Total Recebido",
      value: isLoading ? "..." : fmt(resumo?.totalRecebido ?? 0),
      sub: "Já quitado",
      icon: DollarSign,
      color: "success" as const,
    },
    {
      title: "Saldo Previsto",
      value: isLoading ? "..." : fmt(resumo?.saldoPrevisto ?? 0),
      sub: "Receber - Pagar",
      icon: Wallet,
      color: "warning" as const,
    },
  ];

  return (
    <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-4 h-full">
      {stats.map((stat) => (
        <Card key={stat.title} className="shadow-card hover:shadow-medium transition-all duration-200 border-border/50 h-full">
          <CardContent className="p-5">
            <div className="flex items-start justify-between">
              <div className="space-y-2">
                <p className="text-xs font-medium text-muted-foreground uppercase tracking-wide">
                  {stat.title}
                </p>
                <p className="text-2xl font-bold font-heading text-foreground tracking-tight">
                  {stat.value}
                </p>
                <p className="text-xs font-medium text-muted-foreground">
                  {stat.sub}
                </p>
              </div>
              <div className={`flex h-10 w-10 items-center justify-center rounded-lg ${colorMap[stat.color]}`}>
                <stat.icon className="h-5 w-5" />
              </div>
            </div>
          </CardContent>
        </Card>
      ))}
    </div>
  );
}
